
export const   dropdownItems = {
 
 
"ALEARTS": [
"Input Supply (VIS)",
"Production (VPR)",
"Post-Harvest Handling (VPH)",
"Processing (VPR)",
"Distribution and Marketing (VDM)",
"Consumption (VCO)",
"Support Services (VSS)"

],

"ADVISORY": [
  "Abattoir (ABT)",
  "Aggregator (AGG)",
  "Agrochemical (AGC)",
  "Agro-Dealer (AGD)",
  "Agronomist (AGR)",
  "Apiarist (APR)",
  "Aquaculture (AQU)",
  "Association (ASS)",
  "Auction (ACT)",
  "Bakeries (BAK)",
  "Bank (BAN)",
  "Building Construction (BUC)",
  "Butchery (BUT)",
  "Cafe (CAF)",
  "Chama (CHA)",
  "Cold Logistics (COL)",
  "College (CLL)",
  "Community Based Organization (CBO)",
  "Contract (CON)",
  "Corporate Investor (COI)",
  "Cooperative (COP)",
  "Development Partner (DVP)",
  "Enterprise (ENT)",
  "Equipment Suppliers (EQS)",
  "Farmer (FAM)",
  "Education (EDU)",
  "Electrician (ELE)",
  "Fish Monger (FIM)",
  "Finance (FIN)",
  "Food Processing (FOP)",
  "Green Grocer (GRG)",
  "Green House (GRH)",
  "Government (GOV)",
  "Health Centre (HEC)",
  "Hospitals (HOS)",
  "Hotels (HOT)",
  "Input Supplier (IPS)",
  "Institution (INS)",
  "Investor (INV)",
  "Individual (IND)",
  "Industry Regulator (INR)",
  "Insurance (INS)",
  "Irrigation (IRR)",
  "Laboratory (LAB)",
  "Logistics (LOG)",
  "Machinery Supplier (MH)",
  "Marketing (MAK)",
  "Miller (MIL)",
  "Non-Governmental Organization (NGO)",
  "Not for Profit Organization (NPO)",
  "Offtake Partner (OFP)",
  "Open Market (OPM)",
  "Packaging (PAC)",
  "Parliament (PAR)",
  "Retailer (RET)",
  "Restaurant (RES)",
  "Refrigeration (REF)",
  "Security (SEC)",
  "Service Provider (SEP)",
  "Small Micro Medium Enterprises (SMME)",
  "Supermarkets (SUM)",
  "Survey (SUR)",
  "Technical College (TEC)",
  "Tractor (TRA)",
  "Traders (TRD)",
  "Training (TRN)",
  "University (UNI)",
  "Value Addition (VAA)",
  "Veterinary (VET)",
  "Warehouse (WAH)",
  "Welfare Group (WEG)",
  "School (SCH)",
  "Stokvel (STO)",
  "Group (GRO)",
  "Research (RES)",
  "Standardization (STA)",
  "Stokvel (STO)",
  "Supermarkets (SUM)",
  "Survey (SUR)",
  "Tractor (TRC)",
  "Traders (TRD)",
  "Training (TRI)",
  "University (UNI)",
  "Value Addition (VAL)",
  "Veterinary (VET)",
  "Warehouse (WAR)",
  "Welfare Group (WEG)",
  "Others (OOO)",
],

 
  "FARMING TIPS": [
    "Abattoir (ABT)",
    "Aggregator (AGG)",
    "Agrochemical (AGC)",
    "Agro-Dealer (AGD)",
    "Agronomist (AGR)",
    "Apiarist (APR)",
    "Aquaculture (AQU)",
    "Association (ASS)",
    "Auction (ACT)",
    "Bakeries (BAK)",
    "Bank (BAN)",
    "Building Construction (BUC)",
    "Butchery (BUT)",
    "Cafe (CAF)",
    "Chama (CHA)",
    "Cold Logistics (COL)",
    "College (CLL)",
    "Community Based Organization (CBO)",
    "Contract (CON)",
    "Corporate Investor (COI)",
    "Cooperative (COP)",
    "Development Partner (DVP)",
    "Enterprise (ENT)",
    "Equipment Suppliers (EQS)",
    "Farmer (FAM)",
    "Education (EDU)",
    "Electrician (ELE)",
    "Fish Monger (FIM)",
    "Finance (FIN)",
    "Food Processing (FOP)",
    "Green Grocer (GRG)",
    "Green House (GRH)",
    "Government (GOV)",
    "Health Centre (HEC)",
    "Hospitals (HOS)",
    "Hotels (HOT)",
    "Input Supplier (IPS)",
    "Institution (INS)",
    "Investor (INV)",
    "Individual (IND)",
    "Industry Regulator (INR)",
    "Insurance (INS)",
    "Irrigation (IRR)",
    "Laboratory (LAB)",
    "Logistics (LOG)",
    "Machinery Supplier (MH)",
    "Marketing (MAK)",
    "Miller (MIL)",
    "Non-Governmental Organization (NGO)",
    "Not for Profit Organization (NPO)",
    "Offtake Partner (OFP)",
    "Open Market (OPM)",
    "Packaging (PAC)",
    "Parliament (PAR)",
    "Retailer (RET)",
    "Restaurant (RES)",
    "Refrigeration (REF)",
    "Security (SEC)",
    "Service Provider (SEP)",
    "Small Micro Medium Enterprises (SMME)",
    "Supermarkets (SUM)",
    "Survey (SUR)",
    "Technical College (TEC)",
    "Tractor (TRA)",
    "Traders (TRD)",
    "Training (TRN)",
    "University (UNI)",
    "Value Addition (VAA)",
    "Veterinary (VET)",
    "Warehouse (WAH)",
    "Welfare Group (WEG)",
    "School (SCH)",
    "Stokvel (STO)",
    "Group (GRO)",
    "Research (RES)",
    "Standardization (STA)",
    "Stokvel (STO)",
    "Supermarkets (SUM)",
    "Survey (SUR)",
    "Tractor (TRC)",
    "Traders (TRD)",
    "Training (TRI)",
    "University (UNI)",
    "Value Addition (VAL)",
    "Veterinary (VET)",
    "Warehouse (WAR)",
    "Welfare Group (WEG)",
    "Others (OOO)",
 ],

 "-" : [
  "-"
 ],

 "--" : [
  "-"
 ],

 "---" : [
  "-"
 ]
};
